import { useState } from 'react';
import { httpsCallable, FunctionsError } from 'firebase/functions';
import { functions } from '../firebase';

const generateNextSceneCallable = httpsCallable<{ storyId: string }, { ok: boolean }>(
  functions,
  'generateNextScene',
);

// Shown once every character in the scene has decided. Triggers the next-scene
// generation; the scene-turn spinner takes over as soon as the server flips
// `generating` true, then the new scene appears.
export function GenerateNextButton({ storyId }: { storyId: string }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function go() {
    if (busy) return;
    setBusy(true);
    setError(null);
    try {
      await generateNextSceneCallable({ storyId });
      // Leave busy true — the overlay (driven by story.generating) replaces this.
    } catch (e) {
      setError((e as FunctionsError)?.message ?? 'the story resists');
      setBusy(false);
    }
  }

  return (
    <div className="text-center">
      <button
        type="button"
        onClick={go}
        disabled={busy}
        className="rounded-lg border border-amber-400/60 bg-amber-500/80 hover:bg-amber-400 text-slate-950 font-medium px-4 py-2 text-sm disabled:opacity-50 cursor-pointer"
      >
        {busy ? 'turning the page…' : 'Generate next scene →'}
      </button>
      {error && <p className="mt-1.5 text-xs text-rose-400">{error}</p>}
    </div>
  );
}
